import NewSupplier from './NewSupplier'
export default NewSupplier
